<template>
  <div>
    <div class="teams_homeslider" :class="{'noslides': gameslist.length<=3 }">
      <div class="teams_slider_menu">
        <ul>
          <li>
            <a
              v-bind:class="{ active: selectetype == -1 }"
              @click="loadMatches(-1, null)"
              >All</a
            >
          </li>
          <li
            v-on:click="loadMatches(index, date)"
            v-for="(date, index) in dateslist"
            :key="index"
          >
            <a v-bind:class="{ active: index == selectetype }">{{
              date.dateno
            }}</a>
          </li>
        </ul>
      </div>
      <div v-if="!isloading">
        <div class="slider_navigation">
          <div class="swiper-button-prev home-slider1_left"></div>
          <div class="swiper-button-next home-slider1_right"></div>
        </div>
        <swiper
          ref="awesomeSwiperA"
          :options="swiperOption"
          class="home_main_slider"
        >
          <template v-for="(game, index) in gameslist">
            <swiper-slide :key="index">
              <game @triggerSignup="triggerSignup" :gamedata="game" getHomepageOdds />
            </swiper-slide>
          </template>
        </swiper>
      </div>
      <div class="skeleton_loder" v-if="isloading">
        <v-sheet class="pa-3">
          <v-skeleton-loader
            class="mx-auto"
            max-width="370"
            type="card"
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="mx-auto"
            max-width="370"
            type="card"
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="mx-auto"
            max-width="370"
            type="card"
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="mx-auto"
            max-width="370"
            type="card"
          ></v-skeleton-loader>
        </v-sheet>
      </div>
    </div>
  </div>
</template>



<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import game from "@/views/common/game.vue";
import moment from "moment-timezone";

export default {
  components: {
    game,
    swiper,
    swiperSlide,
  },
  methods: {
    loadMatches(option, selecteddate) {
      clearInterval(this.polling);
      this.selectetype = option;

      if (this.isUserloggeIn) {
        if (option == -1) {
          this.$router.push({
            name: "probability",
          });
        } else {
          this.isloading = true;
          this.homeProbability(selecteddate.date, selecteddate.edate);
          this.pollData();
        }
      } else {
             this.$emit("triggerSignup");
      
      }
    },
    triggerSignup(){
             this.$emit("triggerSignup");

    },
    homeProbability(startdate, enddate) {
      // Convert moment objects to ISO strings if needed (matching backend expectations)
      var startdateStr = startdate && startdate.isValid ? startdate.toISOString() : startdate;
      var enddateStr = enddate && enddate.isValid ? enddate.toISOString() : enddate;
      
      this.$store
        .dispatch("getHomepageOdds", {
          startdate: startdateStr,
          enddate: enddateStr,
        })
        .then((response) => {
          this.isloading = false;

          this.gameslist = [];
          var _games = [];
          if (response && response.length > 0) {
            this.gameslist = response;
          } else {
            this.isloading = false;
          }
        });
    },
    pollData() {
      this.polling = setInterval(() => {
        this.homeProbability(
          this.dateslist[this.selectetype].date,
          this.dateslist[this.selectetype].edate
        );
      }, 36000);
    },
    reloadData(date, index) {
      this.selectedIndex = index;
      this.$emit("reloadProb", {
        date: date.date,
        edate: date.edate,
        reload: false,
      });
    },
  },

  beforeDestroy() {
    clearInterval(this.polling);
  },
  mounted() {
    // Use US Eastern Time for all date calculations (NBA games are scheduled in US time)
    var _s = this;
    var _ds = [0, 1, 2, 3, 4];

    // Get current time in US Eastern Timezone
    var usEasternNow = moment.tz("America/New_York");

    // Calculate date ranges based on US Eastern Time
    _ds.forEach((ekement) => {
      // Calculate date in US Eastern Time
      var usDate = usEasternNow.clone().add(ekement, "days");
      var s = usDate.clone().startOf("day"); // Start of day in US Eastern
      var e = usDate.clone().endOf("day");   // End of day in US Eastern
      
      // Convert to UTC for backend (backend expects UTC ISO strings)
      var sUTC = s.clone().utc();
      var eUTC = e.clone().utc();
      
      var asa = s;

      // Determine label based on US Eastern time
      var usToday = usEasternNow.clone().startOf("day");
      var usTomorrow = usEasternNow.clone().add(1, "days").startOf("day");
      var usYesterday = usEasternNow.clone().add(-1, "days").startOf("day");
      var usNextDay = usEasternNow.clone().add(2, "days").startOf("day");

      if (s.isAfter(usTomorrow)) {
        asa = s.format("MMM-DD");
      } else if (s.isSame(usTomorrow)) {
        asa = "Tomorrow";
      } else if (s.isSame(usToday)) {
        asa = "Today";
      } else if (s.isSame(usYesterday)) {
        asa = "Yesterday";
      } else if (s.isSame(usNextDay)) {
        asa = "Next Day";
      } else {
        asa = s.format("MMM-DD");
      }

      // Store both US Eastern dates (for display) and UTC dates (for API)
      this.dateslist.push({ 
        dateno: asa, 
        date: sUTC,    // UTC start for API
        edate: eUTC    // UTC end for API
      });
    });
    this.isloading = true;

    this.homeProbability(
      this.dateslist[0].date,
      this.dateslist[this.dateslist.length - 1].edate
    );

    this.pollData();
  },
  data: () => ({
    isloading: false,
    selectetype: 0,
    selectedIndex: 0,
    dateslist: [],
    polling: null,
    gameslist: [],
    swiperOption: {
      slidesPerView: "auto",
      spaceBetween: 20, 
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".home-slider1_right",
        prevEl: ".home-slider1_left",
      },
    },
  }),
  computed: {
    isUserloggeIn() {
      return this.$store.state && this.$store.state.user != "";
    },
  },
};
</script>
